/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputAdminTeamSessionShort } from './OutputAdminTeamSessionShort';
import {
    OutputAdminTeamSessionShortFromJSON,
    OutputAdminTeamSessionShortFromJSONTyped,
    OutputAdminTeamSessionShortToJSON,
} from './OutputAdminTeamSessionShort';
import type { OutputDivisionShort } from './OutputDivisionShort';
import {
    OutputDivisionShortFromJSON,
    OutputDivisionShortFromJSONTyped,
    OutputDivisionShortToJSON,
} from './OutputDivisionShort';
import type { OutputZoneShort } from './OutputZoneShort';
import {
    OutputZoneShortFromJSON,
    OutputZoneShortFromJSONTyped,
    OutputZoneShortToJSON,
} from './OutputZoneShort';

/**
 * 
 * @export
 * @interface OutputAdminTeam
 */
export interface OutputAdminTeam {
    /**
     * 
     * @type {string}
     * @memberof OutputAdminTeam
     */
    comment: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OutputAdminTeam
     */
    craftNames: Array<string>;
    /**
     * 
     * @type {OutputDivisionShort}
     * @memberof OutputAdminTeam
     */
    division?: OutputDivisionShort;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminTeam
     */
    divisionId?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminTeam
     */
    droneUid: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminTeam
     */
    flightTimeoutMinutes: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminTeam
     */
    freqRange?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAdminTeam
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminTeam
     */
    name: string;
    /**
     * 
     * @type {OutputAdminTeamSessionShort}
     * @memberof OutputAdminTeam
     */
    session: OutputAdminTeamSessionShort;
    /**
     * 
     * @type {Array<number>}
     * @memberof OutputAdminTeam
     */
    zoneIds: Array<number>;
    /**
     * 
     * @type {Array<OutputZoneShort>}
     * @memberof OutputAdminTeam
     */
    zones: Array<OutputZoneShort>;
}

/**
 * Check if a given object implements the OutputAdminTeam interface.
 */
export function instanceOfOutputAdminTeam(value: object): boolean {
    if (!('comment' in value)) return false;
    if (!('craftNames' in value)) return false;
    if (!('droneUid' in value)) return false;
    if (!('flightTimeoutMinutes' in value)) return false;
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    if (!('session' in value)) return false;
    if (!('zoneIds' in value)) return false;
    if (!('zones' in value)) return false;
    return true;
}

export function OutputAdminTeamFromJSON(json: any): OutputAdminTeam {
    return OutputAdminTeamFromJSONTyped(json, false);
}

export function OutputAdminTeamFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminTeam {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'],
        'craftNames': json['craftNames'],
        'division': json['division'] == null ? undefined : OutputDivisionShortFromJSON(json['division']),
        'divisionId': json['divisionId'] == null ? undefined : json['divisionId'],
        'droneUid': json['droneUid'],
        'flightTimeoutMinutes': json['flightTimeoutMinutes'],
        'freqRange': json['freqRange'] == null ? undefined : json['freqRange'],
        'id': json['id'],
        'name': json['name'],
        'session': OutputAdminTeamSessionShortFromJSON(json['session']),
        'zoneIds': json['zoneIds'],
        'zones': ((json['zones'] as Array<any>).map(OutputZoneShortFromJSON)),
    };
}

export function OutputAdminTeamToJSON(value?: OutputAdminTeam | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'craftNames': value['craftNames'],
        'division': OutputDivisionShortToJSON(value['division']),
        'divisionId': value['divisionId'],
        'droneUid': value['droneUid'],
        'flightTimeoutMinutes': value['flightTimeoutMinutes'],
        'freqRange': value['freqRange'],
        'id': value['id'],
        'name': value['name'],
        'session': OutputAdminTeamSessionShortToJSON(value['session']),
        'zoneIds': value['zoneIds'],
        'zones': ((value['zones'] as Array<any>).map(OutputZoneShortToJSON)),
    };
}

